<!-- eslint-disable vue/no-deprecated-v-bind-sync --> <template>   
<div class="pagination" v-if="total">     
<el-pagination @current-change="pageChange" :current-page.sync="current" :page-size.sync="size" :layout="layout" :total="total">       
<div class="left-pagination">         
<div class="pagination-result">           共 <span>{{ total }}</span> 条         
</div>         
<div class="pagination-result">           
<el-input-number autoId="input_number_size描述文字" v-model="size" @change="handleChange" :precision="0" :min="1" :max="999" label="描述文字" />           条/页          
</div>          
<div class="pagination-jumper">           
<el-input-number autoId="input_number_current" v-model="current" :min="1" :max="Math.ceil(total / size)" :controls="false" @blur="changePage" />            
<div class="jump-to"><i class="el-icon-arrow-right" />
</div>         
</div>       
</div>     
</el-pagination>   
</div> </template>

<script>
/** 分页适配 */
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Pagination',
  props: {
    total: {
      type: Number || String,
      default: 0
    },
    layout: {
      type: String,
      default: 'slot, prev, pager, next'
    },
    pageNum: {
      type: Number || String,
      default: 1
    },
    pageSize: {
      type: Number || String,
      default: 10
    }
  },
  data() {
    return {}
  },
  computed: {
    current: {
      get() {
        return this.pageNum
      },
      set(val) {
        this.$emit('update:pageNum', val)
      }
    },
    size: {
      get() {
        return this.pageSize
      },
      set(val) {
        this.$emit('update:pageSize', val)
      }
    }
  },
  methods: {
    /** 分页变化 */
    pageChange() {
      this.$emit('change', { pageSize: this.size, pageNum: this.current })
    },
    /** 修改一页条数 */
    handleChange() {
      this.current = 1
      this.pageChange()
    },
    /** 跳转页数 */
    changePage() {
      this.pageChange()
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  align-items: flex-end;
  min-width: 400px;
  padding: 10px 0;
  border-top: 1px solid #EEEEEE;
  .left-pagination {
    float: left;
  }
  .pagination-result {
    display: inline-block;
    font-size: 12px;
    color: #999999;
    font-weight: 400;
    :deep(.el-input-number__increase),
    :deep(.el-input-number__decrease) {
      display: none;
    }
    :deep(.el-input-number) {
      outline: none;
      width: 43px;
      height: 20px;
      line-height: 18px;
      text-align: center;
      font-size: 12px;
      background: #ffffff;
      margin: 0 6px;
      input {
        width: 43px;
        height: 20px;
        border: 1px solid #e0e0e0;
        padding: 0;
        border-radius: 0;
      }
    }
    span {
      font-size: 12px;
      color: #000000;
      text-align: center;
      line-height: 16px;
      min-width: 0;
      margin: 0 4px;
      height: inherit;
    }
  }
  .pagination-jumper {
    position: absolute;
    display: flex;
    right: 0;
    top: 2px;
    width: 68px;
    height: 20px;
    border-radius: 2px;
    border: 1px solid #e0e0e0;
    font-size: 12px;
    text-align: center;
    line-height: 18px;
    .el-input-number {
      flex: 1;
      border: none;
    }
    .el-input,
    .el-input-number--medium {
      line-height: 18px;
    }
    :deep(.el-input__inner) {
      border: none;
      height: 18px;
      line-height: 20px;
      padding: 0;
    }
    .jump-to {
      cursor: pointer;
      width: 19px;
      height: 19px;
      color: black;
      border-left: 1px solid #e0e0e0;
    }
  }
  .el-pagination {
    position: relative;
    padding-right: 74px;
    width: 100%;
    text-align: right;
    :deep(.number),
    :deep(.more) {
      width: 20px;
      min-width: 20px;
      height: 20px;
      font-size: 12px;
      line-height: 18px;
      margin: 0 4px;
      padding: 0;
      color: #333333;
      font-weight: 400;
      border-radius: 2px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      background: #fff;
    }
    :deep(.more::before) {
      line-height: 18px;
    }
    :deep(.active) {
      border: 1px solid #5584fb;
      background: #5584fb;
      color: white;
    }
  }
  :deep(.btn-prev),
  :deep(.btn-next) {
    width: 20px;
    height: 20px;
    border: 1px solid #e0e0e0;
    font-size: 12px;
    margin: 0 4px;
    color: #333333;
    padding: 0;
    font-weight: 400;
    min-width: 0;
    &:disabled {
      opacity: 0.5;
    }
  }
}
</style>